import config from "../config/config";


const request = async (path, { method = "GET", body, headers = {}, baseUrl = config.apiUrl } = {}) => {
  const token = localStorage.getItem("token");
  const response = await fetch(`${baseUrl}${path}`, {
    method,
    headers: {
      "Content-Type": "application/json",
      ...(token && { Authorization: `Bearer ${token}` }),
      ...headers,
    },
    ...(body && { body: JSON.stringify(body) }),
  });

  let data = null;
  try {
    data = await response.json();
  } catch {
    // no JSON body
  }

  return { status: response.status, data };
};

// TODO: confirm these paths against the auth-engine backend
const Api = {

  logout: () => request("/auth-engine/logout", { method: "POST" }),
  refreshToken: ({ userToken }) =>
    request("/auth-engine/refresh-token", {
      method: "POST",
      body: { userToken },
    }),
  // Logged-in user's profile — same endpoint the Vectr platform uses after login
  getMe: () => request("/auth-engine/user/me"),
  // Clubbed VIM device list — items carry orgName/activeCount/status/lastSeen
  getProfileDevices: (profileId, orgId, online, page = 1, limit = 100) => {
    const params = new URLSearchParams()
    if (orgId != null) params.set("orgId", orgId)
    if (online != null) params.set("online", online)
    params.set("page", page)
    params.set("limit", limit)
    const query = params.toString()
    return request(`/nsync/profiles/${profileId}/devices?${query}`, {
      baseUrl: config.essApiUrl,
    })
  },
  // BMS list — one item per BMS node with latest telemetry

  getBmsDevices: (profileId, status, orgId, sortBy = 'lastSeen', sortOrder = 'desc', page = 1, limit = 100) =>
    request(`/nsync/bms?profileId=${profileId}&sortBy=${sortBy}&sortOrder=${sortOrder}&page=${page}&limit=${limit}${status ? `&status=${status}` : ''}${orgId != null ? `&orgId=${encodeURIComponent(orgId)}` : ''}`, {
      baseUrl: config.essApiUrl,
    }),
  // Latest BMS snapshot for one node — powers the BMS dashboard's CSV export
  getBmsLatest: (ecuid) =>
    request(`/nsync/bms/${ecuid}/latest`, {
      baseUrl: config.essApiUrl,
    }),
  // BMS telemetry history for one node — from/to are ISO timestamps
  getBmsHistory: (ecuid, from, to) =>
    request(`/nsync/bms/${ecuid}/history?from=${from}&to=${to}`, {
      baseUrl: config.essApiUrl,
    }),
  // VIM device history — from/to are ISO timestamps
  getDeviceHistory: (deviceId, from, to) =>
    request(`/nsync/device/${deviceId}/history?from=${from}&to=${to}`, {
      baseUrl: config.essApiUrl,
    }),
  // VIM online/offline status — populates the Filter modal's Status tab (VIM list only)
  getDeviceOnlineOfflineStatus: () =>
    request(`/nsync/deviceOnlineOflineStatus`, {
      baseUrl: config.essApiUrl,
    }),
  // Last received telemetry snapshot for one VIM device
  getLastTelemetry: (deviceId) =>
    request(`/nsync/getLastTelemetry`, {
      method: "POST",
      body: { deviceId },
      baseUrl: config.essApiUrl,
    }),

  // Latest snapshot for one device incl. its BMS nodes — powers the dashboard CSV export
  getDevicesLatest: (deviceId) =>
    request(`/nsync/devicesLatest?deviceId=${encodeURIComponent(deviceId)}`, {
      baseUrl: config.essApiUrl,
    }),

  getBmsColumns: () =>
    request(`/nsync/keys?deviceType=BMS`, {
      baseUrl: config.essApiUrl,
    }),

  getVimColumns: () =>
    request(`/nsync/keys?deviceType=IOT`, {
      baseUrl: config.essApiUrl,
    }),

  getProfileLinkedCustomers: (profileId) =>
    request(`/device-management/asset-template/organizations/${profileId}`),

  // The nsync profile id every device query is scoped to — responds with a
  // bare number. Fetched once at boot and cached in redux (assetProfileSlice).
  getNsyncProfile: () =>
    request(`/device-management/asset-template/get-nsync-profile`),

  
};

export default Api;
